import React, { useEffect, useRef } from 'react';

import './index.less';
import loadScript from '@/utils/loadScript';

export default function Index(props: { i18n: DetailTypes.i18n; abtest: DetailTypes.Abtest }) {
  const { i18n } = props;

  // 详情装修
  const appendToDesc = () => {
    // 插入详情装修
    const myIdElement = document.getElementById('layout-other');
    const myIdElementWrapper = document.getElementById('layout-other-wrapper');
    if (myIdElement && myIdElementWrapper) {
      myIdElementWrapper.appendChild(myIdElement);
    }
  };

  useEffect(() => {
    appendToDesc();
  }, []);

  return (
    <div className="description-layout" id="description-layout">
      <h3 className="att-title" id="more-detail">
        {i18n['detail_pc_more_details']}
      </h3>
      <div id="layout-other-wrapper"></div>
    </div>
  );
}
